import { getDefaultConfig } from "../../Config/getDefaultConfig";
import { updateInitialConfig, updateModifiedConfig } from "../checksumStore";

export const updateEntityChecksum = (entityData, smData, initActData, isInit = false) => {
  const entity = processEntityConfig(entityData);
  const initAct = processInitActivityConfig(initActData);
  const sm = processStateMachineConfig(smData);
  const storeConfig = {
    entityConfig: entity,
    smConfig: initAct,
    cartConfig: sm
  };
  if (isInit) {
    updateInitialConfig(storeConfig);
  } else {
    updateModifiedConfig(storeConfig);
  }
  return storeConfig;
};

const processEntityConfig = (entityData) => {
  return { unique_fields: entityData.unique_fields || [] };
};

const processInitActivityConfig = (actData) => {
  return {
    jobs_trigger: actData.jobs_trigger || [],
    pre_activity_job: actData.pre_activity_job || [],
    jobs_trigger_formula: actData.jobs_trigger_formula,
    pre_submission: actData.pre_submission || [],
    activity_owner_assignment: actData.activity_owner_assignment,
    state_change_logic: actData.state_change_logic,
    description: actData.description,
    activity_response: actData.activity_response
  };
  //   return { unique_fields: smData.unique_fields };
};

const processStateMachineConfig = (smData) => {
  return {
    sm_trigger_job: smData.sm_trigger_job || [],
    pro_code: smData.pro_code,
    cart_detailview: {
      elements: smData.cart_detailview.elements || [],
      cart_action: smData.cart_detailview.cart_action || getDefaultConfig("button")
    }
  };
};
